<template>
	<div class="sidebar-footer bg-body rounded-lg py-0.5" :class="{ collapsed }">
		<n-menu :options="menuOptions" :collapsed :collapsed-width :indent="18" />
	</div>
</template>

<script lang="ts" setup>
import type { I18nString } from "@/lang/config"
import { NMenu } from "naive-ui"
import { computed, h, ref } from "vue"
import { useI18n } from "vue-i18n"
import { RouterLink } from "vue-router"
import { useThemeStore } from "@/stores/theme"
import { renderIcon } from "@/utils"

const { collapsed = false } = defineProps<{
	collapsed?: boolean
}>()

const { t } = useI18n()

const menuOptions = ref([
	{
		label: () =>
			h(
				RouterLink,
				{
					to: {
						name: "Logout"
					}
				},
				{ default: () => t<I18nString>(`navigation.menu.logout`) }
			),
		key: "Logout",
		icon: renderIcon("ion:log-out-outline")
	}
])

const themeStore = useThemeStore()
const collapsedWidth = computed<number>(() => themeStore.sidebar.closeWidth - 16)
</script>
